import { setCampaignsDashboardWizard } from "app/components/dashboard/widget-wizard/campaignsWizardRegistry";

import { CampaignsDashboardWizard } from "./CampaignsDashboardWizard";

export const registerCampaignsDashboardWizard = (): void => {
    setCampaignsDashboardWizard(CampaignsDashboardWizard);
};
